export default __webpack_public_path__ + "static/cannabis-835b724c80ff0500dfc06140f61fac5e.jpg";